// import React, { useEffect } from "react";
// import { Fancybox as NativeFancybox } from "@fancyapps/ui";
// // import "@fancyapps/ui/dist/fancybox.css";

// const Fancybox = ({ children }) => {
//   useEffect(() => {
//     NativeFancybox.bind("[data-fancybox]", {});
//     return () => {
//       NativeFancybox.unbind("[data-fancybox]");
//       NativeFancybox.close();
//     };
//   }, []);

//   return <>{children}</>;
// };

// export default Fancybox;

import React, { useRef, useEffect, PropsWithChildren } from "react";

import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { classNames } from "../../helpers/classNames";

const Fancybox = (props) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;

    const delegate = props.delegate || "[data-fancybox]";
    const options = props.options || {};

    NativeFancybox.bind(container, delegate, options);

    return () => {
      NativeFancybox.unbind(container);
      // NativeFancybox.close();
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className={classNames("fancy-box", props?.className)}
    >
      {props.children}
    </div>
  );
};

export default Fancybox;
